import { createFileRoute, useRouter } from '@tanstack/react-router'
import { useAtom } from 'jotai/index'
import { useEffect } from 'react'

import Logo from '@/containers/logo'

import Spinner from '@/components/spinner'
import { ModeToggle } from '@/components/theme/mode-toggle.tsx'

import { authTokenAtom } from '@/state/authToken.tsx'
import { useIdentity } from '@/state/identity.tsx'

import ForgotPasswordForm from './-components/forgot-password-form.tsx'

export const Route = createFileRoute('/forgot-password/')({
    component: ForgotPasswordComp,
})

function ForgotPasswordComp() {
    const [authToken] = useAtom(authTokenAtom)
    const { identity } = useIdentity()
    const router = useRouter()

    useEffect(() => {
        if (identity) {
            // Hard refresh redirect on login do avoid potential state issues
            location.href = '/'
        }
    }, [identity, router.history])

    if (identity || authToken) {
        return <Spinner size="md" absolute />
    }

    return (
        <div className="relative grid h-screen flex-col items-center justify-center px-4 lg:max-w-none lg:grid-cols-2 lg:px-0">
            <div className="absolute right-8 top-8">
                <ModeToggle />
            </div>
            <div className="mx-auto hidden h-full w-full flex-col items-center justify-center bg-muted lg:flex">
                <Logo className="mb-4 mr-2" />
                <h1 className="text-2xl font-semibold tracking-tight">Moxie Markets</h1>
            </div>
            <div className="lg:p-8">
                <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]">
                    <div className="visible mx-auto mb-12 flex w-full flex-col items-center justify-center text-center lg:hidden">
                        <Logo className="mb-4 mr-2" />
                        <h1 className="text-2xl font-semibold tracking-tight">Moxie Markets</h1>
                    </div>
                    <div className="flex flex-col space-y-2 text-center">
                        <h1 className="text-2xl font-semibold tracking-tight">Forgot password</h1>
                    </div>
                    <ForgotPasswordForm />
                </div>
            </div>
        </div>
    )
}
